export const COURSE_DATA = "COURSE_DATA";
export const SESSION_DATA  = "SESSION_DATA";